import { render } from "./ContactCardBasic.vue?vue&type=template&id=0bfc49cf"
import script from "./ContactCardBasic.vue?vue&type=script&lang=js"
export * from "./ContactCardBasic.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__